export default {"src":"/_next/static/media/logo_stroke_blue.eaebbcd1.svg","height":221,"width":368,"blurWidth":0,"blurHeight":0};